import "./Contact.css";

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-header">
        <span className="contact-tag">CONTACT</span>
        <h2>
          Get In <span>Touch</span>
        </h2>
      </div>

      <div className="contact-container">
        {/* LEFT FORM */}
        <div className="contact-form-card">
          <form
            action="https://shirdhankartechwork.getform.com/vz20d"
            method="POST"
          >
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
              />
              <input
                type="email"
                name="email_1"
                placeholder="Email Address"
                required
              />
            </div>

            <textarea
              name="message"
              placeholder="Tell us about your project..."
              required
            ></textarea>

            {/* Optional redirect after submit */}
            <input
              type="hidden"
              name="_redirect"
              value="https://shirdhankartechnologies.com/#contact"
            />

            <button type="submit">
              Send Message
            </button>
          </form>
        </div>

        {/* RIGHT INFO */}
        <div className="contact-info">
          <h3>Let’s discuss your project</h3>
          <p>
            Whether you need a website, mobile app, custom software, or an
            immersive game — we’re here to make it happen.
          </p>

          <div className="info-item">
            <span>✉️</span>
            <span>contact@shirdhankartechnologies.com</span>
          </div>

          <div className="info-item">
            <span>📞</span>
            <span>+91 9653304639</span>
          </div>

          <div className="info-item">
            <span>📍</span>
            <span>India · Serving Clients Worldwide</span>
          </div>

         <div className="map-box">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28733.62822707531!2d72.87603200000001!3d18.723635199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be879e34c41771f%3A0xe374d2b528a205d!2sShirdhankar%20Technologies!5e1!3m2!1sen!2sin!4v1770876500272!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Shirdhankar Technologies Location"
  ></iframe>
</div>


        </div>
      </div>
    </section>
  );
}

export default Contact;
